import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { DocumentTemplateEditorController } from 'src/app/general/document-templates/parts/document-template-editor.controller';
import { EmailTargetEditorController } from 'src/app/general/email-document-template/parts/email-target-editor.controller';
import { EmailTemplatePreviewView } from 'src/app/general/email-document-template/parts/email-template-preview.view';
import { EmailTemplatePreviewController } from 'src/app/general/email-document-template/parts/email-template-preview.controller';
import { EmailTemplateEditor } from 'src/app/general/email-document-template/parts/email-templates.editor';


interface SendInvoiceDocumentExecutorProps {
	onFieldChange: (field: string, value: any) => void;
	values?: { [id: string]: any };
	mode: ControlMode;
}

@observer
export class SendInvoiceDocumentExecutor extends React.Component<SendInvoiceDocumentExecutorProps, any> {
	constructor(props) {
		super(props);

	}

	public componentDidMount() {
		if (this.props.values)
			this.props.values.validate = () => {

				
				if (!this.props.values['documentTemplateId'])
					return { result: false, errors: "The document template is required in SendInvoiceDocumentExecutor. \n" };

				if (!this.props.values['emailTemplateId'])
					return { result: false, errors: "The email template is required in SendInvoiceDocumentExecutor \n" };
				
				return { result: true, errors: "" };
			}
	}


	render() {

		const { values } = this.props;
		
		return (
			<React.Fragment>

				<Row gutter={24}>
					<Col xs={24}>


						<p>Send the invoice document rendered using the document template id</p>

						<DocumentTemplateEditorController
							label=''
							required
							value={this.props.values["documentTemplateId"]}
							mode={this.props.mode}
							onChanged={(e) => this.props.values["documentTemplateId"] = e.id}
							setBusy={() => ({})}
							usage="Quotes"
						/>

						<p>The email template will be the email document template selected</p>

						<EmailTemplateEditor
							required
							model={this.props.values["emailTemplateId"]}
							mode={this.props.mode}
							onChanged={(e) => this.props.values["emailTemplateId"] = e.id}
						/>
					</Col>
				</Row>
				
			</React.Fragment>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/executors/send-invoice-document.tsx